import {tg} from "../telegram";

export function openFile(link: string) {
    tg.WebApp.openLink(link);
}